import {setUnauthorizedHandler} from '@rocket-ui/lk-api';
import {getDefaultStore} from 'jotai';
import {tokenAtom} from 'features/auth/model/authAtom';
import {incrementSessionCount} from 'features/auth/model/sessionCount';

let isHandlingUnauthorized = false;

export function setupUnauthorizedRedirect(): void {
	setUnauthorizedHandler(() => {
		if (isHandlingUnauthorized) return;

		isHandlingUnauthorized = true;
		incrementSessionCount();
		getDefaultStore().set(tokenAtom, null);
		window.location.replace('/auth/login');
	});
}
